/**
 * テーマのモーダル表示を解除する。
 * - body: is-presenting-modal / pdp-custom-options-open
 * - PDP カスタムオプション等（他スクリプトが公開する関数があれば呼び出し）
 * - #modal-container 内 HTML（sticky の modal-cart 等）
 */
(function () {
  'use strict';
  window.themeDismissModalPresentation = function () {
    document.body.classList.remove('is-presenting-modal');
    document.body.classList.remove('pdp-custom-options-open');
    if (typeof window.pdpCloseCustomOptionsOverlay === 'function') {
      window.pdpCloseCustomOptionsOverlay();
    } else {
      var pdp = document.getElementById('pdp-custom-options-overlay');
      if (pdp) {
        pdp.classList.add('hidden');
        pdp.setAttribute('aria-hidden', 'true');
      }
    }
    if (typeof window.closeLineItemPropertiesModal === 'function') {
      window.closeLineItemPropertiesModal();
    }
    if (typeof window.themeCloseCVariantModalsIfOpen === 'function') {
      window.themeCloseCVariantModalsIfOpen();
    }
    var host = document.getElementById('modal-container');
    if (host) host.innerHTML = '';
  };
})();

// SideMenu Accordion
(function () {
  'use strict';
  function initSceneAccordion() {
    var triggers = document.querySelectorAll('.search__item-list-accordion-trigger');
    triggers.forEach(function (trigger) {
      if (trigger.getAttribute('data-action') && trigger.getAttribute('data-action').indexOf('accordion#toggle') !== -1) {
        return;
      }
      // 矢印ボタン専用トグルがある場合は行全体クリックで開閉しない
      if (trigger.querySelector('.search__item-list-accordion-trigger-toggle')) {
        return;
      }
      trigger.addEventListener('click', function () {
        var expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !expanded);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSceneAccordion);
  } else {
    initSceneAccordion();
  }
})();

// PDP 商品説明アコーディオン
(function () {
  'use strict';
  function initProductDescriptionAccordion() {
    document.querySelectorAll('.c-product-description-accordion__toggle').forEach(function (toggle) {
      if (toggle.getAttribute('data-accordion-bound') === 'true') return;
      toggle.setAttribute('data-accordion-bound', 'true');
      toggle.addEventListener('click', function () {
        var content = toggle.nextElementSibling;
        if (!content || !content.classList.contains('c-product-description-accordion__content')) return;
        toggle.classList.toggle('is-active');
        content.classList.toggle('is-open');
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductDescriptionAccordion);
  } else {
    initProductDescriptionAccordion();
  }
})();


// Custom Accordion
(function() {
  const accordions = document.querySelectorAll('.c-accordion');
  const openOneOnly = false; // true: 1つだけ開く / false: 複数開閉可

  accordions.forEach(function(accordion) {
    const items = accordion.querySelectorAll('.c-accordion__item');

    items.forEach(function(item) {
      // Stimulus accordion（GSAP）配線済みはスキップ
      var controller = item.getAttribute('data-controller') || '';
      if (controller.indexOf('accordion') !== -1) return;

      const toggle = item.querySelector('.c-accordion__item-toggle');
      if (!toggle) return;

      toggle.addEventListener('click', function() {
        const isOpen = item.classList.contains('is-open');

        if (openOneOnly) {
          items.forEach(function(other) {
            other.classList.remove('is-open');
            const t = other.querySelector('.c-accordion__item-toggle');
            if (t) t.setAttribute('aria-expanded', 'false');
          });
        }

        if (!isOpen) {
          item.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        } else if (!openOneOnly) {
          item.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });
  });
})();

/**
 * カートページでの購入制限
 * custom.max_qty_per_sku_per_customer（bundle.js と同じ API / 判定）
 * カートページ（main-cart-items）のチェックアウト前検証で利用。
 * 過去注文数＋カート内数量が上限「以下」なら購入可（上限ちょうどは OK）。
 */
(function () {
  'use strict';
  var NS = (window.familiarMaxSkuCart = window.familiarMaxSkuCart || {});

  NS.showMaxSkuQtyCartAlert = function (maxQty, productTitle) {
    var alertEl = document.querySelector('.js-alert-max-sku-qty-cart');
    if (!alertEl) return;
    var title = alertEl.querySelector('.alert__title');
    if (title) {
      var name = productTitle != null ? String(productTitle).trim() : '';
      var prefix = name ? name + 'は' : 'こちらの商品は';
      title.textContent =
        prefix + '1アカウントあたり' + maxQty + '点までご購入いただけます。';
    }
    alertEl.classList.add('show');
    document.body.classList.add('is-presenting-alert');
  };

  NS.canAddWithMaxSkuPerCustomer = function (productId, sku, maxSkuAllowed, cart, customerEmailOverride) {
    return new Promise(function (resolve) {
      var el = document.getElementById('max-qty-data-element');
      if (!el) {
        console.error('maxQtyDataElement not found.');
        resolve(false);
        return;
      }
      var maxAllowed = parseInt(String(maxSkuAllowed), 10) || 0;
      if (maxAllowed <= 0) {
        resolve(true);
        return;
      }

      var customerId = el.dataset.customer_id;
      var isGuest = el.dataset.is_guest === 'true';
      var email =
        customerEmailOverride != null ? String(customerEmailOverride).trim() : '';
      var noCustomer =
        !String(customerId || '').trim() && !email;
      var currentPage = el.dataset.current_page;
      var hmac = el.dataset.hmac;
      var items = (cart && cart.items) || [];
      var cartQtyForSku = items.reduce(function (sum, item) {
        if (item.sku === sku && String(item.product_id) === String(productId)) {
          return sum + item.quantity;
        }
        return sum;
      }, 0);

      if (noCustomer) {
        resolve(cartQtyForSku <= maxAllowed);
        return;
      }
      if (isGuest && currentPage === 'product') {
        resolve(cartQtyForSku <= maxAllowed);
        return;
      }

      var apiUrl = window.API_URL && window.API_URL.getOrderedProductSkuCount;
      if (!apiUrl) {
        console.error('API_URL.getOrderedProductSkuCount is not defined.');
        resolve(false);
        return;
      }

      fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customerId: customerId,
          hmac: hmac,
          productId: productId,
          productSku: sku,
          maxSkuAllowed: maxAllowed,
          customerEmail: customerEmailOverride != null ? customerEmailOverride : null
        })
      })
        .then(function (res) {
          if (!res.ok) {
            console.error('Non-200 response:', res.status);
            resolve(false);
            return null;
          }
          return res.json();
        })
        .then(function (data) {
          if (data == null) return;
          var ordered =
            data.orderedSkuCount && data.orderedSkuCount[sku] != null
              ? data.orderedSkuCount[sku]
              : 0;
          resolve(ordered + cartQtyForSku <= maxAllowed);
        })
        .catch(function (err) {
          console.error('Fetch error:', err);
          resolve(false);
        });
    });
  };

  /**
   * rulesObj: { "1": { product_id, sku, max_quantity }, ... }（bundle の max_qty_metafields_json と同形）
   * @returns {Promise<{ ok: boolean, maxQtyForMessage: number, productTitle: string }>}
   */
  NS.validateCartAgainstMaxSkuRules = function (cart, rulesObj) {
    var keys = Object.keys(rulesObj || {});
    return keys.reduce(
      function (chain, key) {
        return chain.then(function (acc) {
          if (!acc.ok) return acc;
          var r = rulesObj[key];
          var maxQ = parseInt(String(r.max_quantity), 10) || 0;
          if (maxQ <= 0) return acc;
          var pid = String(r.product_id);
          var sku = r.sku != null ? String(r.sku) : '';
          return NS.canAddWithMaxSkuPerCustomer(
            pid,
            sku,
            maxQ,
            cart,
            null
          ).then(function (allowed) {
            if (allowed) {
              return { ok: true, maxQtyForMessage: 0, productTitle: '' };
            }
            var lineTitle = '';
            var items = (cart && cart.items) || [];
            for (var i = 0; i < items.length; i++) {
              var it = items[i];
              if (
                String(it.product_id) === pid &&
                String(it.sku || '') === String(sku || '')
              ) {
                lineTitle =
                  (it.product_title != null && String(it.product_title).trim()) ||
                  (it.title != null && String(it.title).trim()) ||
                  '';
                break;
              }
            }
            return {
              ok: false,
              maxQtyForMessage: maxQ,
              productTitle: lineTitle
            };
          });
        });
      },
      Promise.resolve({ ok: true, maxQtyForMessage: 0, productTitle: '' })
    );
  };

  NS.rulesHaveAnyMaxSku = function (rulesObj) {
    if (!rulesObj || typeof rulesObj !== 'object') return false;
    for (var k in rulesObj) {
      if (!Object.prototype.hasOwnProperty.call(rulesObj, k)) continue;
      var mq = parseInt(String(rulesObj[k].max_quantity), 10) || 0;
      if (mq > 0) return true;
    }
    return false;
  };

  NS.patchMaxQtyDataElementFromCartRulesJson = function () {
    var rulesEl = document.getElementById('cart-line-max-sku-rules-json');
    var mq = document.getElementById('max-qty-data-element');
    if (!rulesEl || !mq) return;
    var raw = (rulesEl.textContent || '').trim();
    if (!raw) return;
    mq.dataset.max_qty_metafields_json = raw;
  };

  NS.submitMainCartCheckout = function (form) {
    var checkoutBtn =
      document.getElementById('cart-checkout-submit') ||
      form.querySelector('button[name="checkout"]');

    if (checkoutBtn && typeof form.requestSubmit === 'function') {
      form.setAttribute('data-max-sku-checkout-bypass', '1');
      form.requestSubmit(checkoutBtn);
      return;
    }

    if (!form.querySelector('input[name="checkout"][data-max-sku-checkout-input]')) {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'checkout';
      hidden.setAttribute('data-max-sku-checkout-input', '1');
      form.appendChild(hidden);
    }
    HTMLFormElement.prototype.submit.call(form);
  };

  NS.lockMainCartCheckoutForMaxSku = function () {
    var btn = document.querySelector(
      'button.button--cta.button--has-icon-cart[name="checkout"][form="cart"]'
    );
    if (btn) {
      btn.setAttribute('disabled', 'disabled');
      btn.classList.add('disabled');
      btn.setAttribute('aria-disabled', 'true');
    }
    var pickup = document.getElementById('js-checkout-store-pickup');
    if (pickup && !pickup.getAttribute('data-max-sku-pickup-locked')) {
      pickup.setAttribute('data-max-sku-pickup-locked', '1');
      if (!pickup.getAttribute('data-href-backup')) {
        pickup.setAttribute('data-href-backup', pickup.getAttribute('href') || '');
      }
      pickup.removeAttribute('href');
      pickup.classList.add('disabled');
      pickup.setAttribute('aria-disabled', 'true');
      pickup.setAttribute('tabindex', '-1');
      pickup.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopPropagation();
        },
        true
      );
    }
  };

  /**
   * ページ表示時: 過去注文＋カートで SKU 上限超えならアラート＋チェックアウト／店舗取寄リンクを無効化
   */
  NS.applyMainCartMaxSkuViolationsOnLoad = function () {
    var rulesEl = document.getElementById('cart-line-max-sku-rules-json');
    if (!rulesEl) return;
    var rules;
    try {
      rules = JSON.parse(rulesEl.textContent || '{}');
    } catch (err) {
      return;
    }
    if (!rules || typeof rules !== 'object') return;
    if (!NS.rulesHaveAnyMaxSku(rules)) return;

    NS.patchMaxQtyDataElementFromCartRulesJson();

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        return NS.validateCartAgainstMaxSkuRules(cart, rules);
      })
      .then(function (result) {
        if (result && result.ok) return;
        var mq = result && result.maxQtyForMessage ? result.maxQtyForMessage : 0;
        var pt = result && result.productTitle ? result.productTitle : '';
        if (mq > 0) {
          NS.showMaxSkuQtyCartAlert(mq, pt);
        } else {
          NS.showMaxSkuQtyCartAlert(1, pt);
        }
        NS.lockMainCartCheckoutForMaxSku();
      })
      .catch(function () {});
  };

  NS.initMainCartCheckoutMaxSkuGuard = function () {
    var rulesEl = document.getElementById('cart-line-max-sku-rules-json');
    var form = document.getElementById('cart');
    if (!rulesEl || !form) return;

    NS.patchMaxQtyDataElementFromCartRulesJson();

    var rules;
    try {
      rules = JSON.parse(rulesEl.textContent || '{}');
    } catch (err) {
      return;
    }
    if (!rules || typeof rules !== 'object') return;
    if (!NS.rulesHaveAnyMaxSku(rules)) return;

    if (form.getAttribute('data-max-sku-checkout-guard') === '1') return;
    form.setAttribute('data-max-sku-checkout-guard', '1');

    form.addEventListener('submit', function (e) {
      if (form.getAttribute('data-max-sku-checkout-bypass') === '1') {
        form.removeAttribute('data-max-sku-checkout-bypass');
        return;
      }
      if (e.submitter && e.submitter.getAttribute('name') !== 'checkout') return;
      e.preventDefault();
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          return NS.validateCartAgainstMaxSkuRules(cart, rules);
        })
        .then(function (result) {
          if (result && result.ok) {
            NS.submitMainCartCheckout(form);
            return;
          }
          var mq = result && result.maxQtyForMessage ? result.maxQtyForMessage : 0;
          var pt = result && result.productTitle ? result.productTitle : '';
          if (mq > 0) {
            NS.showMaxSkuQtyCartAlert(mq, pt);
          } else {
            NS.showMaxSkuQtyCartAlert(1, pt);
          }
          NS.lockMainCartCheckoutForMaxSku();
        })
        .catch(function () {});
    });
  };

  function bootCartMaxSku() {
    var rulesEl = document.getElementById('cart-line-max-sku-rules-json');
    if (!rulesEl) return;
    var rules;
    try {
      rules = JSON.parse(rulesEl.textContent || '{}');
    } catch (e) {
      return;
    }
    if (!rules || typeof rules !== 'object' || !NS.rulesHaveAnyMaxSku(rules)) return;

    NS.patchMaxQtyDataElementFromCartRulesJson();
    NS.initMainCartCheckoutMaxSkuGuard();
    NS.applyMainCartMaxSkuViolationsOnLoad();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootCartMaxSku);
  } else {
    bootCartMaxSku();
  }
})();

/**
 * カスタムオプション（line item properties）バリデーション
 * - allowed_charactersで許可文字種制御
 * - カート追加ボタンは非活性にせず、クリック時にエラー表示・先頭項目へスクロール
 */
(function () {
  'use strict';

  var CHAR_CLASSES = {
    ひらがな: '\u3041-\u3096\u309D-\u309F',
    カタカナ: '\u30A0-\u30FF\uFF66-\uFF9D',
    漢字: '\u4E00-\u9FFF\u3400-\u4DBF\u3005',
    'アルファベット（大・小文字）': 'A-Za-z',
    'アルファベット（大文字）': 'A-Z',
    数字: '0-9'
  };

  var MSG = {
    empty: '入力してください。',
    unselected: '選択してください。',
    invalidChars: '使用できない文字が含まれています。',
    maxLength: function (n) {
      return n + '字以内で入力してください。';
    }
  };

  function parseAllowedChars(el) {
    var raw = el.getAttribute('data-allowed-chars');
    if (!raw || !String(raw).trim()) return null;
    try {
      var arr = JSON.parse(raw);
      if (!Array.isArray(arr) || !arr.length) return null;
      return arr.map(function (v) {
        return String(v).trim();
      });
    } catch (err) {
      return null;
    }
  }

  function isAllowedValue(value, allowedList) {
    if (!allowedList || !allowedList.length) return true;
    if (!value) return true;
    var parts = [];
    allowedList.forEach(function (label) {
      if (CHAR_CLASSES[label]) parts.push(CHAR_CLASSES[label]);
    });
    if (!parts.length) return true;
    var re = new RegExp('^[' + parts.join('') + ']+$');
    return re.test(value);
  }

  function validateField(el) {
    var isSelect = el.tagName === 'SELECT';
    var required = el.getAttribute('data-custom-option-required') === 'true';
    var raw = el.value != null ? String(el.value) : '';
    var trimmed = raw.trim();

    if (isSelect) {
      if (required && !raw) {
        return { ok: false, message: MSG.unselected, el: el };
      }
      return { ok: true, el: el };
    }

    if (required && !trimmed) {
      return { ok: false, message: MSG.empty, el: el };
    }

    if (trimmed) {
      var allowed = parseAllowedChars(el);
      if (allowed && !isAllowedValue(trimmed, allowed)) {
        return { ok: false, message: MSG.invalidChars, el: el };
      }
      var maxLen = parseInt(el.getAttribute('data-max-length') || '', 10);
      if (!maxLen) maxLen = parseInt(el.getAttribute('maxlength') || '', 10);
      if (maxLen > 0 && trimmed.length > maxLen) {
        return { ok: false, message: MSG.maxLength(maxLen), el: el };
      }
    }

    return { ok: true, el: el };
  }

  function clearFormErrors(root) {
    var scope = root || document;
    scope.querySelectorAll('.js-custom-option-error').forEach(function (errEl) {
      errEl.hidden = true;
      errEl.textContent = '';
    });
    scope.querySelectorAll('.js-custom-option-field.border-red').forEach(function (field) {
      field.classList.remove('border-red');
    });
  }

  function uniqueMessages(messages) {
    var seen = {};
    var list = [];
    (messages || []).forEach(function (msg) {
      if (!msg || seen[msg]) return;
      seen[msg] = true;
      list.push(msg);
    });
    return list;
  }

  function setFormError(formEl, messages) {
    if (!formEl) return;
    var list = uniqueMessages(Array.isArray(messages) ? messages : [messages]);
    if (!list.length) return;
    var errEl = formEl.querySelector('.js-custom-option-error');
    if (!errEl) {
      errEl = document.createElement('p');
      errEl.className = 'product-form__error js-custom-option-error';
      formEl.appendChild(errEl);
    }
    errEl.textContent = '';
    list.forEach(function (msg, i) {
      if (i > 0) errEl.appendChild(document.createElement('br'));
      errEl.appendChild(document.createTextNode(msg));
    });
    errEl.hidden = false;
  }

  function scrollToField(el) {
    if (!el || typeof el.scrollIntoView !== 'function') return;
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /**
   * 同一 form内のエラー表示を現在の入力状態で更新（重複メッセージは出さない）
   */
  function refreshFormErrors(formEl) {
    if (!formEl) return true;
    var messages = [];
    var allOk = true;
    formEl.querySelectorAll('.js-custom-option-field').forEach(function (field) {
      var result = validateField(field);
      if (result.ok) {
        field.classList.remove('border-red');
        return;
      }
      allOk = false;
      field.classList.add('border-red');
      messages.push(result.message);
    });
    var errEl = formEl.querySelector('.js-custom-option-error');
    if (allOk) {
      if (errEl) {
        errEl.hidden = true;
        errEl.textContent = '';
      }
      return true;
    }
    setFormError(formEl, messages);
    return false;
  }

  /**
   * @returns {{ ok: boolean, firstInvalid: Element|null }}
   */
  function validateCustomOptions(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll('.js-custom-option-form');
    if (!forms.length) {
      return { ok: true, firstInvalid: null };
    }

    clearFormErrors(scope);

    var firstInvalid = null;
    var allOk = true;

    forms.forEach(function (formEl) {
      var fields = formEl.querySelectorAll('.js-custom-option-field');
      var messages = [];
      fields.forEach(function (field) {
        var result = validateField(field);
        if (result.ok) return;
        allOk = false;
        field.classList.add('border-red');
        messages.push(result.message);
        if (!firstInvalid) firstInvalid = field;
      });
      if (messages.length) setFormError(formEl, messages);
    });

    if (firstInvalid) scrollToField(firstInvalid);
    return { ok: allOk, firstInvalid: firstInvalid };
  }

  function keepAtcEnabled() {
    var btn = document.getElementById('js-pdp-custom-options-atc');
    if (btn) btn.classList.remove('disabled');
  }

  function bindFieldClear() {
    function onFieldEdit(e) {
      var field = e.target && e.target.closest && e.target.closest('.js-custom-option-field');
      if (!field) return;
      var formEl = field.closest('.js-custom-option-form');
      if (!formEl) return;
      // エラー表示中のみ、残りエラーを重複なく再描画
      var errEl = formEl.querySelector('.js-custom-option-error');
      if (!errEl || errEl.hidden) {
        field.classList.remove('border-red');
        return;
      }
      refreshFormErrors(formEl);
    }
    document.addEventListener('input', onFieldEdit);
    document.addEventListener('change', onFieldEdit);
  }

  function initCustomOptionsValidation() {
    keepAtcEnabled();
    bindFieldClear();

    // 旧バリデーションの disabled 再付与を打ち消す
    var atc = document.getElementById('js-pdp-custom-options-atc');
    if (atc && typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(function () {
        if (atc.classList.contains('disabled')) atc.classList.remove('disabled');
      });
      mo.observe(atc, { attributes: true, attributeFilter: ['class'] });
    }

    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest && e.target.closest('#js-pdp-custom-options-atc');
        if (!btn) return;
        var overlay = document.getElementById('pdp-custom-options-overlay');
        var root = overlay || document;
        var result = validateCustomOptions(root);
        if (result.ok) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      },
      true
    );

    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.querySelector) return;
        if (!form.querySelector('.js-custom-option-field')) return;
        if (typeof window.syncLineItemDatetimeHiddens === 'function') {
          window.syncLineItemDatetimeHiddens();
        }
        var result = validateCustomOptions(form);
        if (result.ok) return;
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );
  }

  window.validateCustomLineItemOptions = validateCustomOptions;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomOptionsValidation);
  } else {
    initCustomOptionsValidation();
  }
})();